import { Designer } from './Designer.js';
import { autofillSurface } from '../autoFill/index.js';
import type { CropType, IPhoto, IProject, ISurface } from '../common/index.js';
import { CalendarPhotosSelector } from './photosSelector/CalendarPhotosSelector.js';
import { isUserPhotoAsset } from '../common/utils/index.js';

export class CalendarDesigner extends Designer {

    private readonly photosSelector: CalendarPhotosSelector;

    public constructor(project: IProject | undefined, photos: IPhoto[] | undefined, cropStrategy?: CropType) {
        super(project, photos, cropStrategy);
        this.photosSelector = new CalendarPhotosSelector(photos ?? []);
    }

    public designProject(): IProject {
        const filledSurfaces: ISurface[] = [];
        const photoBatchSize = Math.max(1, Math.round(this.photos.length / this.project.surfaces.length));

        for (const surface of this.project.surfaces) {
            const batch = this.photosSelector.getSortedBatch(photoBatchSize);

            const updatedSurface = autofillSurface(surface, batch, this.cropStrategy);

            filledSurfaces.push(updatedSurface);

            for (const asset of updatedSurface.assets) {
                if (isUserPhotoAsset(asset) && asset.content?.photoId) {
                    this.photosSelector.updatedPhotoSet(asset.content.photoId);
                }
            }
        }

        return {
            ...this.project,
            photos: this.photosSelector.getUsedPhotos(),
            surfaces: filledSurfaces,
        };
    }

}
